module.exports = __webpack_public_path__ + "static/media/fungames.3d70fe9e.gif";